
<template>
    <div class="container animated bounceInRight">
        <div v-if="Array.isArray(availableResearches) && !availableResearches.length">
            <div class="row mt-5">
                <div class="col-md-12 centered">
                    <i class='fas fa-clipboard-list fa-3x green'></i>
                    <h3>
                        Não há pesquisas disponíveis no momento.
                    </h3>
                    <h6>
                        Obrigado pelo comprometimento em responder as nossas pesquisas de clima organizacional!
                    </h6>
                </div>
            </div>
        </div>
        <div>
            <div v-for="research in availableResearches" :key="research.id">
                <div class="card centered">
                    <div class="card-title centered mt-3">
                        <h3>
                            {{ research.name }}
                        </h3>
                    </div>
                    <div class="card-body">
                        <div class='row mb-2'>
                            <div class="col-12">
                                <h6>
                                    <b>Ciclo: </b>
                                    {{ research.cycle.name }}
                                </h6>
                            </div>
                            <div class="col-12">
                                <img src="../../assets/images/research.jpg" class="research-img">
                            </div>
                            <div class="col-12 mt-5">
                                <router-link :to="'/research/' + research.id" class="btn btn-normal btn-block">Responder pesquisa</router-link>
                            </div>
                            
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                availableResearches: null
            }
        },
        computed: {
            
        },
        methods: {
            getAvailableResearches(){
                const self = this
                const api = self.$store.state.api + 'researches/availables'
                self.$http.get(api)
                    .then((response) => {
                        self.availableResearches = response.data
                    }).catch((error) => {
                        self.$message('Erro', error.response.data, 'error')
                    });
            }
        },
        mounted: function(){
           const self = this
           self.getAvailableResearches()
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Main/Home.vue